/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS202: Simplify dynamic range loops
 * DS206: Consider reworking classes to avoid initClass
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
// Code to activate the React-based TokenInput for a specific input
import $ from 'jquery';
import _ from 'underscore';
import React from 'react';
import ReactDOM from 'react-dom';
import { TokenInput } from '../react/token_input.jsx';

// Splits a string on commas, unless the comma is in double quotes
//
// Returns an array of terms, without any quoting
const splitTagList = function(str) {
      let in_quote = false;
      let was_quoted = false;
      let term_start = 0;
      const terms = [];

      for (let i = 0, end = str.length, asc = 0 <= end; asc ? i <= end : i >= end; asc ? i++ : i--) {
        if (str[i] === '"') { // If it's a double quote
          if (!in_quote) { was_quoted = true; }
          in_quote = !in_quote;

        } else if (!in_quote && (str[i] === ',')) {
          let found_term = str.substr(term_start, i - term_start).trim();
          if (was_quoted) { // strip leading/trailing quotes
            was_quoted = false;
            found_term = found_term.replace(/^"|"$/g, '');
          }

          terms.push(found_term);
          term_start = i + 1;
        }
      }

      if (term_start <= str.length) {
        terms.push(str.substr(term_start).trim());
      }

      return terms;
    };

export class TokenTagInput {
  constructor(element, options) {
          if (options == null) { options = {}; }
          this.element = $(element);
        
          // Convert data attribute options to the appropriate value
          const data_options = {};
          if (options.tokenInputId) {
            data_options.id = options.tokenInputId;
            delete options.tokenInputId;
          }
          if (options.tokenInputInitial) {
            data_options.initial_value = options.tokenInputInitial;
            delete options.tokenInputInitial;
          }
          if (options.tokenInputPlaceholder) {
            data_options.placeholder = options.tokenInputPlaceholder;
            delete options.tokenInputPlaceholder;
          }
          if (options.tokenInputName) {
            data_options.name = options.tokenInputName;
            delete options.tokenInputName;
          }
          // assumes an array of objects being used if key exists and is true
          if (options.hasOwnProperty("tokenInputIsSubmittedString")) {
            data_options.is_submitted_string = options.tokenInputIsSubmittedString;
            delete options.tokenInputIsSubmittedString;
          } else {
            // assumes comma delimited string (original implementation)
            data_options.is_list = true;
          }
        
          this.options = _.extend({}, this.default_options, data_options, options);

          this.options.initial_list = [];

          if (typeof(this.options.initial_value) === 'string') {
            if (!this.options.initial_value.isBlank()) { this.options.initial_list = splitTagList(this.options.initial_value); }
          } else {
            if (data_options.initial_value.length !== 0) { this.options.initial_list = data_options.initial_value; }
          }

          // Attach react component
          ReactDOM.render(React.createElement(TokenInput, {
            placeholder:            this.options.placeholder,
            autocompleteSuggestURL: this.options.autocomplete_suggest_url,
            name:                   this.options.name,
            items:                  this.options.initial_list,
            onItemAdded:            this.options.on_item_added,
            onItemRemoved:          this.options.on_item_removed,
            isSubmittedString:      this.options.is_submitted_string,
            id:                     this.options.id
          }
          ), this.element.get(0));
        }
}

TokenTagInput.prototype.default_options = {
  name: 'tags',
  initial_list: [],
  initial_value: '',
  placeholder: 'Type something and press Enter',
  autocomplete_suggest_url: null,
  on_item_added: null,
  on_item_removed: null
};

TokenTagInput.prototype.element = null;

// Expose on the Slzr.UI namespace so server-rendered inline scripts (ERB) can
// reference the class without needing a webpack import.
namespace('Slzr.UI', function(exports) {
  exports.TokenTagInput = TokenTagInput;
});